
import mock from "./data/mock.js";
import InstagramImage from './components/InstagramImage.vue'
import InstagramMappedImage from './models/InstagramImage.js'
import FIcon from '@fixit/icons/src/components/FIcon.vue'
import DepartmentSelector from "./components/DepartmentSelector"

export default {
  components: {
    InstagramImage,
    DepartmentSelector,
    FIcon,
  },
  props: {
    salons: {
      type: Array,
      required: false,
      default: () => {
        []
      }
    },
    title: {
      type: String,
      required: false,
      default: 'Siste bilder fra våre avdelingers Instagram-kontoer'
    },
    salonSelector: {
      type: Boolean,
      requried: false,
      default: true
    },
    images: {
      type: Array,
      required: false,
      default: () => {
        return [];
      },
    },
    maxNumberOfImages: {
      type: Number,
      required: false,
      default: 14
    }
  },
  data() {
    return {
      currentSiteId: 0,
      isMounted: false,
    };
  }, 
  methods: {
    changeSalon(value) {
      this.currentSiteId = value
    }
  },
  mounted() {
    this.isMounted = true;
  },
  computed: {
    mappedSalons () {
      const salons = this.instagramImages.map(x => ({
        siteName: x.siteName,
        siteId: x.siteId
      }))

      return salons
    },
    instagramImages() {
      
      let mappedMockimages = mock.mockImages.map(x => new InstagramMappedImage(x))

      mappedMockimages.sort(function (a, b) {
        if (a.timestamp > b.timestamp) {
          return -1
        }
      })

      if (this.images == null || this.images == undefined) {
        return mappedMockimages;
      }

      if (!this.images.length) {
        return this.images
      }

      if (this.currentSiteId > 0) {
        this.images = this.images.filter(x => x.siteId === this.currentSiteId)
      }

      this.images.sort(function (a, b) {
        if (a.timestamp > b.timestamp) {
          return -1
        }
      })
      
      return this.images.map(x => new InstagramMappedImage(x));
    },
    filteredInstagramImages() {
      let images = this.instagramImages

      if (this.currentSiteId > 0) {
        images = images.filter(x => x.siteId === this.currentSiteId)
      }
 
      return images.slice(0, this.maxNumberOfImages)
    },
  },
};
